import React from 'react';
import {Tooltip} from '@mui/material';
import InsightsIcon from '@mui/icons-material/Insights';
import ArticleIcon from '@mui/icons-material/Article';
import CampaignIcon from '@mui/icons-material/Campaign';
import GavelIcon from '@mui/icons-material/Gavel';
import FolderIcon from '@mui/icons-material/Folder';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import DescriptionIcon from '@mui/icons-material/Description';
import {productTypeBadgeLabel} from './productTypes';

const ICON_MAP = {
    analytic: InsightsIcon,
    fintel: InsightsIcon,
    iir: ArticleIcon,
    pitch: SlideshowIcon,
    tactical_sitrep: CampaignIcon,
    strategic_sitrep: CampaignIcon,
    disclosure: GavelIcon,
    ndp1_disclosure: GavelIcon,
    collection_material: FolderIcon,
};

/**
 * Small inline icon representing a product type, with a tooltip showing the type label.
 * Renders nothing when productType is absent.
 */
export default function ProductTypeIcon({productType, sx, ...props}) {
    const key = typeof productType === 'string' ? productType.trim().toLowerCase() : '';
    const Icon = ICON_MAP[key] || (key ? DescriptionIcon : null);
    if (!Icon) return null;

    const label = productTypeBadgeLabel(productType) || productType;
    return (
        <Tooltip title={label} placement="top" arrow>
            <Icon
                sx={{
                    fontSize: 14,
                    verticalAlign: 'middle',
                    color: 'text.secondary',
                    ml: 0.5,
                    flexShrink: 0,
                    ...sx,
                }}
                {...props}
            />
        </Tooltip>
    );
}
